import React, { createContext, useState, useEffect } from 'react';

export const AuthContext = createContext();

const AuthProvider = ({ children }) => {
    const [userName, setUserName] = useState('');
    const [token, setToken] = useState('');

    useEffect(() => {
        const storedUser = sessionStorage.getItem('userName');
        const storedToken = sessionStorage.getItem('token');

        setUserName(storedUser);
        setToken(storedToken);
    }, []);

    const login = (name, tokenValue) => {
        sessionStorage.setItem('userName', name);
        sessionStorage.setItem('token', tokenValue);
        setUserName(name);
        setToken(tokenValue);
    };

    const logout = () => {
        sessionStorage.removeItem('userName');
        sessionStorage.removeItem('token');
        setUserName('');
        setToken('');
    };

    return (
        <AuthContext.Provider value={{ userName, token, login, logout }}>
            {children}
        </AuthContext.Provider>
    );
};

export default AuthProvider;